import axios from "axios";
import store from "../Store/Store";
import { userLogout } from "../Store/_redux/AuthStore/authActions";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Request interceptor — token ekleme + FormData desteği
api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("@authToken");

    if (token && token !== "null") {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.token = token; // Eski 'token' header doğrulamasını da destekle
    }

    // FormData için Content-Type'ı kaldır (axios otomatik multipart boundary eklesin)
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor — token süresi dolunca yönlendirme
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Session expired — redirecting to login...");

      // Redux + localStorage temizle
      localStorage.removeItem("token");
      localStorage.removeItem("@authToken");
      localStorage.removeItem("persist:root");

      try {
        store.dispatch(userLogout());
      } catch (err) {
        console.warn("Logout dispatch skipped:", err);
      }

      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
